module.exports = __webpack_public_path__ + "img/logo_tokyoit.8ac0dd22.png";